import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
const initialState: UpdateCardDetailPayload = {
  updateCardInfo: {
    UpdateCardID: '',
    Title: '',
    Name: '',
    IncludedSegments: [],
    translationLanguageList: [],
    Status: '',
    CreatedAtUTC: '',
    StartDateUTC: '',
    EndDateUTC: '',
    SubHeader1: '',
    SubHeader2: '',
    ImageUrl: '',
    UiPosition: 0,
    ImageID: '',
    Icon: null,
    Description: '',
    CtaLabel: null,
    CtaLink: null,
    selectedLanguage: '',
    selectedLanguageName: '',
    defaultLanguage: {
      Title: null,
      SubHeader1: null,
      SubHeader2: null,
      Description: null,
      CtaLabel: null
    },
    translations: {
      UpdateCardTranslationID: null,
      Title: null,
      SubHeader1: null,
      SubHeader2: null,
      Description: null,
      CtaLabel: null,
      LanguageCode: null
    }
  },
  updateCardBadges: []
}

export const updateCardSlice = createSlice({
  name: 'updateCard',
  initialState,
  reducers: {
    setUpdateCard: (state, action: PayloadAction<UpdateCardDetailPayload>) => {
      return action.payload
    },
    setUpdateCardSelectedTranslations: (
      state,
      action: PayloadAction<SetUpdateCardTranslationParms>
    ) => {
      return {
        ...state,
        updateCardInfo: {
          ...state.updateCardInfo,
          selectedLanguage: action.payload.selectedLanguage,
          selectedLanguageName: action.payload.selectedLanguageName,
          defaultLanguage: action.payload.defaultLanguage,
          translations: {
            UpdateCardTranslationID:
              action.payload.translations?.UpdateCardTranslationID ?? null,
            Title: action.payload.translations?.Title ?? null,
            SubHeader1: action.payload.translations?.SubHeader1 ?? null,
            SubHeader2: action.payload.translations?.SubHeader2 ?? null,
            Description: action.payload.translations?.Description ?? null,
            CtaLabel: action.payload.translations?.CtaLabel ?? null,
            LanguageCode: action.payload.selectedLanguage
          }
        }
      }
    }
  }
})

export const { setUpdateCard, setUpdateCardSelectedTranslations } =
  updateCardSlice.actions

export const updateCardReducer = updateCardSlice.reducer
